import { firstAllowed, requirePermissions } from '@/app/requirePermissions';
import { PagePermissions } from '@/models/pagePermissions';

export const transactionsRoute = {
  path: 'transactions',
  children: [
    {
      path: '',
      loader: firstAllowed([
        { to: 'store', oneOf: PagePermissions.transactionsStore },
        { to: 'inventory', oneOf: PagePermissions.transactionsInventory },
      ]),
    },
    {
      path: 'store',
      loader: requirePermissions({ oneOf: PagePermissions.transactionsStore }),
      lazy: () => import('./store'),
    },
    {
      path: 'inventory',
      loader: requirePermissions({
        oneOf: PagePermissions.transactionsInventory,
      }),
      lazy: () => import('./inventory'),
    },
  ],
};
